import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"

import { DynamicCommonFilters } from "@components"
import {GROUPED_BY, COMMON_FILTERS_COMPONENTS, MONITORING_ROUTES} from "@constants"
import { useUserApp } from "@hooks"
import { PRICING_ROUTES } from "@constants"
import { isLoadingCommonFilters, groupedBy } from "@signals"
import { elementsInLoading, isLoadingByGroupToggle } from "./@signals"


export default function PriceDiscountnNewFilters() {
	const { mainSite, userRole } = useUserApp()
	const { singleCountryUser } = useUserApp()

	const siteProps = userRole === 'retailerUser' ? { excludeOptions: mainSite } : {}

	useEffect(() => {
		if (singleCountryUser) groupedBy.value = GROUPED_BY.RETAILER
	}, [])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
			isLoadingByGroupToggle.value = false
		})
	}, [elementsInLoading.value.length])

	return <Box data-tour="price-discount-filters">
	<DynamicCommonFilters
		uniqueID={PRICING_ROUTES.OVERVIEW_ID}
        blockID={PRICING_ROUTES.ACCESS_KEY}
        components={[
            { name: COMMON_FILTERS_COMPONENTS.FAV_FILTERS, grid: { xs: 3 }, hide: false, dashboardKey: PRICING_ROUTES.OVERVIEW_ID },
			{ name: COMMON_FILTERS_COMPONENTS.PRODUCTS_IN_STOCK, grid: { xs: 2 }, hide: false },
			{ name: COMMON_FILTERS_COMPONENTS.WITH_SHIPPING_PRICE, grid: { xs: 3 }, hide: false },
            { name: COMMON_FILTERS_COMPONENTS.DATE_RANGE, grid: { xs: 2 }, hide: false },
            { name: COMMON_FILTERS_COMPONENTS.SHOW_MORE_FILTERS, grid: { xs: 2 }, sx: {display: 'flex', justifyContent: 'flex-end'} },
			{ name: COMMON_FILTERS_COMPONENTS.MARKET, grid: { xs: 3 } },
			{ name: COMMON_FILTERS_COMPONENTS.RETAILER, grid: { xs: 5 }, ...siteProps },
			{ name: COMMON_FILTERS_COMPONENTS.CATEGORY, grid: { xs: 4 } },
			{ name: COMMON_FILTERS_COMPONENTS.BRAND, grid: { xs: 3 } },
			{ name: COMMON_FILTERS_COMPONENTS.SKU_GROUP, grid: { xs: 3 } },
			{ name: COMMON_FILTERS_COMPONENTS.SKU, grid: { xs: 6 }, showAdornment: true },
        ]}
	/>
	</Box>
}
